export default __webpack_public_path__ + "static/media/Lycanthropic Morph.d509bb5d.jpg";